import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';
import { CommonService } from './services/common.service';
import { LoginService } from './services/login.service';
import { filter } from 'rxjs/operators';
import { AlertService } from './services/alert.service';
import { ThemeService } from '@dxc-technology/halstack-angular';
import { customTheme } from 'src/assets/css/customTheme';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'SOE-LifeClaimOffice';
  idpConfiguration;
  ON_PREMISES_CAS = environment.ON_PREMISES_CAS;
  ON_PREMISES = environment.ON_PREMISES;
  ON_CLOUD = environment.ON_CLOUD;
  PROFILE = environment.ENV_ACTIVE_PROFILE;
  isAuthorized: boolean = false;
  hasIdtoken: any;
  hasAccessToken: any;
  userName: any;
  currentUrlSegments: any;
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;

  claimsMenu = [
    {
      id: 1,
      name: 'Assure Insights',
      path: 'admin',
      icon:
        this.RESOURCE_SERVER_URL +
        '/assets/images/Claim_Office/Side_Menu/Assure_Insights.svg',
    },
    {
      id: 2,
      name: 'Process Claims',
      path: 'process-claims',
      icon:
        this.RESOURCE_SERVER_URL +
        '/assets/images/Claim_Office/Side_Menu/Process_Claims.svg',
      isSelected: false,
    },
    {
      id: 3,
      name: 'Claims',
      path: 'billing-administration',
      icon:
        this.RESOURCE_SERVER_URL +
        '/assets/images/Claim_Office/Side_Menu/Claims.svg',
      isSelected: false,
    },
  ];
  isMenuOpened: boolean = true;
  mobile: boolean = false;
  activatedURL: any;
  userId: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public translate: TranslateService,
    private oauthService: OAuthService,
    private loginService: LoginService,
    private commonService: CommonService,
    private alertService: AlertService,
    @Inject('ThemeService') private themeService: ThemeService,
  ) {
    this.idpConfiguration = environment.IDP;
    this.configureSingleSignOn();
    let region=sessionStorage.getItem('regionSelected')
    let localregion=localStorage.getItem('regionSelected');
    if(region != undefined && region!= null && region != ''){
      localStorage.setItem('regionSelected',region)
    }else if(localregion == undefined || localregion == null || localregion == '' || localregion == 'undefined'){
       let locationURl = this.router['location']._platformStrategy;
      // let baseHref = locationURl._baseHref.split('/');
      let regionSelecte = locationURl._platformLocation.location.pathname.split(`/`, 3);
      localStorage.setItem('regionSelected', regionSelecte[regionSelecte.length-1]);
      sessionStorage.setItem('regionSelected',regionSelecte[regionSelecte.length-1]);
    }
  }
  configureSingleSignOn() {
    this.oauthService.configure(this.idpConfiguration);
    this.oauthService.loadDiscoveryDocumentAndTryLogin();
  }
  async environmentURLSetup() {
    if (this.ON_PREMISES === this.PROFILE) {
      // onPremises enviroment
      this.configureSingleSignOn();
    } else if (this.ON_CLOUD === this.PROFILE) {
      // Congito environment
    }
  }
  async ngOnInit() {
    this.themeService.registerTheme(customTheme);
    this.environmentURLSetup();
    if (this.ON_PREMISES === this.PROFILE) {
      // OIDC enviroment (OKTA,o Auth0, etc....)
      this.onOIDCEnviroment();
    }
    // Congito environment
    else if (this.ON_CLOUD === this.PROFILE) {
      this.onCognitoEnvironment();
    }
    // CAS Environment
    else if (this.PROFILE === this.ON_PREMISES_CAS) {
      this.onCASEnviroonment();
    }
    if (localStorage.getItem('access_token') == 'permanentToken') {
      //provide access
    } else if (
      localStorage.getItem('access_token') != null &&
      localStorage.getItem('access_token') != undefined &&
      localStorage.getItem('access_token') != ''
    ) {
      this.getUserRoles();
    }
    this.commonService.loadhelpjson();
  }
  // OIDC enviroment (OKTA,o Auth0, etc....)
  onOIDCEnviroment() {
    if (sessionStorage.getItem('nonce')) {
      this.isAuthorized = true;
      this.hasIdtoken = this.oauthService.hasValidIdToken();
      this.hasAccessToken = this.oauthService.hasValidAccessToken();
      setTimeout(async () => {
        let tokenInfo = await this.commonService.get_tokenInfo();
        this.commonService.getUserInfo();
        let userdetails = await this.loginService.getUserRoles(
          tokenInfo.preferred_username
        );
        if (userdetails.userRole.length != 0) {
          if (
            userdetails.userName != null &&
            userdetails.userName != undefined &&
            userdetails.userName != ''
          ) {
            localStorage.setItem('profilename', userdetails.userName);
          }
        }
        this.lookUpAfterTokenSet(500);
      }, 3000);
    } else {
      this.oauthService.initLoginFlow();
    }
  }
  // Congito environment
  onCognitoEnvironment() {
    let isLogin = sessionStorage.getItem('isLogin');
    if (isLogin !== 'yes') {
      this.loginService.redirectToLogin();
    } else {
      this.isAuthorized = true;
      this.activatedRoute.queryParams.subscribe((params) => {
        if (params.code) {
          //getting access token
          this.getCognitoToken(params);
        }
      });
    }
  }
  
  getCognitoToken(params){
    this.loginService.getAccessToken(params.code).then(async (res) => {
      // getting tokeninfo
      let tokenInfo = await this.commonService.get_tokenInfo();
      if (tokenInfo.identities != undefined) {
        this.userId = tokenInfo.identities[0].userId;
      } else {
        this.userId = tokenInfo.email;
      }
      localStorage.setItem('userName', this.userId);
      this.loginService
        .getUserRoles(this.userId)
        .then((res) => {
          if (res.userRole.length != 0) {
            if (
              res.userName != null &&
              res.userName != undefined &&
              res.userName != ''
            ) {
              localStorage.setItem('profilename', res.userName);
            }
            let isValid = this.loginService.isValidUserRole(res);
            this.lookUpAfterTokenSet(2000);
            if (!isValid) {
              this.isAuthorized = false;
              this.router.navigate(['/unauthorize']);
            } else {
              this.isAuthorized = true;
            }
          } else {
            this.isAuthorized = false;
            this.router.navigate(['/unauthorize']);
          }
        })
        .catch((err) => {
          this.isAuthorized = false;
          this.router.navigate(['/unauthorize']);
        });
    });
  }

  // CAS Environment
  onCASEnviroonment() {
    let isLogin = sessionStorage.getItem('isLogin');
    if (isLogin !== 'yes') {
      this.loginService.CAS_LoginPage();
    } else {
      this.isAuthorized = true;
      this.activatedRoute.queryParams.subscribe((params) => {
        if (params.code) {
          this.getCASToken(params);
        }
      });
    }
  }

  getCASToken(params) {
    this.loginService.getToken_CAS(params.code).then(async (res) => {
      //geting token
      let token = res.access_token;
      localStorage.setItem('access_token', token);
      //getting user Info
      let tokenInfo = await this.commonService.get_tokenInfo();
      this.userId = tokenInfo.sub;
      localStorage.setItem('userName', this.userId);
      this.loginService
        .getUserRoles(this.userId)
        .then((res) => {
          if (res.userRole.length != 0) {
            if (
              res.userName != null &&
              res.userName != undefined &&
              res.userName != ''
            ) {
              localStorage.setItem('profilename', res.userName);
            }
            let isValid = this.loginService.isValidUserRole(res);
            this.lookUpAfterTokenSet(500);
            if (!isValid) {
              this.isAuthorized = false;
              this.router.navigate(['/unauthorize']);
            } else {
              this.isAuthorized = true;
            }
          } else {
            this.isAuthorized = false;
            this.router.navigate(['/unauthorize']);
          }
        })
        .catch((err) => {
          this.isAuthorized = false;
          this.router.navigate(['/unauthorize']);
        });
    });
  }

  async getUserRoles() {
    try {
      let userdetails = await this.loginService.getUserRoles(
        localStorage.getItem('userName')
      );
      if (userdetails.userRole.length != 0) {
        this.lookUpAfterTokenSet(0);
        if (
          userdetails.userName != null &&
          userdetails.userName != undefined &&
          userdetails.userName != ''
        ) {
          localStorage.setItem('profilename', userdetails.userName);
        }
        let isValid = this.loginService.isValidUserRole(userdetails);
        if (!isValid) {
          this.isAuthorized = false;
          this.router.navigate(['/unauthorize']);
        } else {
          this.isAuthorized = true;
        }
      } else {
        this.isAuthorized = false;
        this.router.navigate(['/unauthorize']);
      }
    } catch (error) {
      this.commonService.changespinnerMessage(false);
      this.alertService.error(error);
      this.isAuthorized = false;
      this.router.navigate(['/unauthorize']);
    }
  }
  //check url
  checkUrl() {
    this.router.events

      .pipe(filter((event) => event instanceof NavigationEnd))

      .subscribe((e: NavigationEnd) => {
        this.currentUrlSegments = e.url.split('/');

        for (let value of this.currentUrlSegments) {
          if (
            value == 'unauthorize' ||
            value == 'login'
          ) {
            this.isAuthorized = false;
          } else {
            this.isAuthorized = true;
          }
        }
      });
  }
  checkResponsive() {
    this.mobile = window.screen.width < 992;
  }

  navigateToDetails(item) {
    let path = item.path;
    this.router.navigate([path], { relativeTo: this.activatedRoute });
    this.navigateSelect();
  }

  navigateSelect() {
    let snapshot: any = this.activatedRoute.snapshot;
    this.claimsMenu.forEach(function (menu, i) {
      if (snapshot['_routerState'].url.search(menu.path) != -1) {
        menu.isSelected = true;
      }
    });
  }
  sideBarToggler() {
    this.isMenuOpened = !this.isMenuOpened;
  }

  lookUpAfterTokenSet(settime) {
    this.navigateSelect();
    this.checkResponsive();
    this.checkUrl();
    this.getlanguagelist()
  }
  async getlanguagelist(){
    try {
       const res = await this.commonService.getLanguageLookup();
      const language = await this.commonService.getAllDropdownList();
      let ress=await this.commonService.getAllLifeLookUp()
      if (language) {
      let countryselected=localStorage.getItem('regionSelected');
      let updatedlanguagelist=res['country_language'].filter(data=>data.value==countryselected)
      let country= environment.IsAllianzEnv == 'Y'?'PHL':'SGP';
      if(updatedlanguagelist.length == 0){
        localStorage.setItem('regionSelected',country);
        updatedlanguagelist=res['country_language'].filter(data=>data.value == country);
      }
      localStorage.setItem('language',updatedlanguagelist[0].Default_Language.toLowerCase())
      localStorage.setItem('currency',updatedlanguagelist[0].Default_Currency)
      this.translate.setDefaultLang(updatedlanguagelist[0].Default_Language.toLowerCase());
      this.translate.use(updatedlanguagelist[0].Default_Language.toLowerCase());
        delete updatedlanguagelist[0].label;
        delete updatedlanguagelist[0].value;
        delete updatedlanguagelist[0].Country;
        delete updatedlanguagelist[0].Default_Language;
        delete updatedlanguagelist[0].Default_Currency;
        let languageList = Object.keys(updatedlanguagelist[0]);
        let optionsLanguages = []
        for (let k = 0; k < languageList.length; k++) {
          let labe = `Language ${k + 1 < 10 ? '0' : ''}${k + 1}`;
          if (updatedlanguagelist[0][labe] != '') {
            let filterlist = language.language_Setup.filter(data => data.value == updatedlanguagelist[0][labe])
            if(filterlist.length !=0){
              optionsLanguages.push({value:filterlist[0].value.toLowerCase(),label:filterlist[0].label})
              }
          }
        }
        this.commonService.dynamicLanguagelist([])
      }
    } catch (error) {
    }
  }
  doLogout() {
    //testing latest ui code change 2023/08/03 13:35
    localStorage.clear();
    sessionStorage.clear();
    console.log('dologout from app')
    // OIDC enviroment (OKTA,o Auth0, etc....)
    if (this.PROFILE === this.ON_PREMISES) {
      this.oauthService.logOut();
    } else if (this.PROFILE == this.ON_CLOUD) {
      let logOut =
        environment.COGNITO.logoutURL +
        '?client_id=' +
        environment.COGNITO.ClientId +
        '&response_type=' +
        environment.COGNITO.response_type +
        '&scope=' +
        environment.COGNITO.scope +
        '&redirect_uri=' +
        environment.COGNITO.CAS_SERVER_URL +
        '&identity_provider=' +
        environment.COGNITO.identity_provider;
      window.open(logOut, '_self');
    }
    // CAS environment
    else if (this.PROFILE == this.ON_PREMISES_CAS) {
      window.open(environment.OAUTH2_CAS.logoutURL, '_self');
    }
  }
  tokenExit() {
    if (
      localStorage.getItem('access_token') != null &&
      localStorage.getItem('access_token') != undefined &&
      localStorage.getItem('access_token') != ''
    ) {
      return true;
    } else {
      return false;
    }
  }
}
